export class PagedListResponseDto {
  data: Array<any>;
  count: number;
  total: number;
  page: number;
  pageCount: number;
}

/** Generic version of the `PagedListResponseDto`.*/
export class PagedListResponseGenDto<T> {
  data: Array<T>;
  count: number;
  total: number;
  page: number;
  pageCount: number;
}
